import { render, staticRenderFns } from "./trip_linker_report_tbn.vue?vue&type=template&id=210c947b&scoped=true&"
import script from "./trip_linker_report_tbn.vue?vue&type=script&lang=js&"
export * from "./trip_linker_report_tbn.vue?vue&type=script&lang=js&"
import style0 from "./trip_linker_report_tbn.vue?vue&type=style&index=0&id=210c947b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "210c947b",
  null
  
)

export default component.exports